<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->

        <config-title-hang>
          <span slot="config_title_hang_ele2">在线主机列表</span>
          <img slot="config_title_hang_ele5_img" src="~assets/img/config/shuaxin_bai.png" alt
            @click="shuaXinBtnHandle" />
          <span slot="config_title_hang_ele5" @click="shuaXinBtnHandle">刷新</span>
        </config-title-hang>

        <config-hang v-for="(value ) in serveHostListData.onLineList" :key="value.gatewayId"
          @click.native="oneHostFindProductBtnHandle(value, 1)">
          <!-- // 代号 20241212-1 -->
          <span slot="config_hang_ele2_1" :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
            {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.gatewayTypeName :
              value.gatewayTypeName
            }}
          </span>
          <span slot="config_hang_ele2_2">
            [{{ value.borderAddress }}|{{ value.uniqueCode16 }}|{{ value.intranetIp }}]
          </span>
          <!-- <span slot="config_hang_ele3">{{ value.uniqueCode16 }}</span> -->
          <span slot="config_hang_ele3">{{ value.gatewayName }}</span>


          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-title-hang v-show="serveHostListData.offLineList.length != 0">
          <span slot="config_title_hang_ele2">离线主机列表</span>
        </config-title-hang>

        <config-hang v-for="(value ) in serveHostListData.offLineList" :key="value.gatewayId"
          @click.native="oneHostFindProductBtnHandle(value, 0)">
          <!-- // 代号 20241212-1 -->
          <span slot="config_hang_ele2_1" :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
            {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.gatewayTypeName :
              value.gatewayTypeName
            }}
          </span>
          <span slot="config_hang_ele2_2">
            [{{ value.borderAddress }}|{{ value.uniqueCode16 }}|{{ value.intranetIp }}]
          </span>
          <!-- <span slot="config_hang_ele3">{{ value.uniqueCode16 }}</span> -->
          <span slot="config_hang_ele3">{{ value.gatewayName }}</span>

          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>


        <div class="xiaotishi_style">
          小提示:边界主机的地址不可重复,范围2-254,非边界主机的地址默认0或1.
          <br>
          小提示:若出现错误提示,解决后,需再次回到本页面刷新结果。
        </div>

        <!-- <config-hang v-for="(value ) in serveHostListData.offLineList" :key="value.gatewayId">
          <span slot="config_hang_ele2">{{value.gatewayName}}</span>
          <span slot="config_hang_ele3">{{value.intranetIp}}</span>

          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>-->
      </div>
    </div>
  </div>
</template>
<script>
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from "components/common/config/config-title-hang";

import configHang from "components/common/config/config-hang";
export default {
  data() {
    return {
      serveHostListData: {
        ////服务器请求到的主机列表
        offLineList: [],
        onLineList: []
      }
    };
  },
  components: {
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    shuaXinBtnHandle() {
      ///刷新按钮被点击了
      /// 请求用户的网关列表接口，获取数据
      this.$request({
        method: "post",
        url: "/gateway/findGatewayByUserList",
        data: {
          token: this.$store.state.token,
          gatewayType: 0 ////0 代表正常网关，不传则代表所有
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.serveHostListData = res.data.data; ////拿到服务器返回的数据结果
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    oneHostFindProductBtnHandle(value, state) {
      ////一个主机被点击了
      // this.$router.push("deviceGoOnlineManage");
      this.$store.dispatch("asyUpdataoneHostData", value); ///异步提交更新一个主机的信息到仓库
      ///获取网关下的产品列表 接口，获取数据
      this.$request({
        method: "post",
        url: "/product/findProductListByGatewayId",
        data: {
          token: this.$store.state.token,
          gatewayId: value.gatewayId,
          typeId: "",
          state: state
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceListData = res.data.data; ////拿到服务器返回的数据结果

            this.$store.dispatch(
              "asyUpdataoneHostDeviceListData",
              res.data.data
            ); ///异步提交信息到仓库

            //代号 20241212-1
            if (res.data.data.pageJumpType == "485Gateway") {
              this.$router.push("deviceGoOnlineManage");  ////请求成功后在跳转 避免出现BUG
            }
            else if (res.data.data.pageJumpType == "threadGateway") {
              this.$router.push("threadDeviceGoOnlineManage");  ////请求成功后在跳转 避免出现BUG
            }
            else {
              this.$showTipsToast(3, "未知的主机类型,请联系技术人员!");
            }

            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });

    }
  },

  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    /// 请求用户的网关列表接口，获取数据
    this.$request({
      method: "post",
      url: "/gateway/findGatewayByUserList",
      data: {
        token: this.$store.state.token,
        gatewayType: 0 ////0 代表正常网关，不传则代表所有
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveHostListData = res.data.data; ////拿到服务器返回的数据结果
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style></style>
